import React from "react";
import Button from "./Button";

/**
 * SecondaryButton - Gray button for secondary actions
 * 
 * Use for: Close, Cancel, Back, Skip
 * 
 * @example
 * <SecondaryButton onClick={onClose}>
 *   Close
 * </SecondaryButton>
 */
const SecondaryButton = (props) => {
  return <Button variant="gray" {...props} />;
};

export default SecondaryButton;

